module.exports = __webpack_public_path__ + "img/ic_nav_home.a33fbe5c.svg";